import { ANDROID_WRAPPER_EVENTS } from '@/event-manager/types';
import { ERROR_TYPE } from '@/features/Popup/constants';
import {
  SoftReloadPreset,
  SOFT_RELOAD_PRESET,
} from '@/lostHooks/softReload/softReloadPresets';
import { resetGameStore } from '@/store/actions';
import { GameStoreParts } from '@/store/slices/game/types';
import { sendAndroidWrapperEvent, triggerXsellLogin } from '../wrapperHelpers';
import { useStore } from '@/store/useStore';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { isCurrentLocalSessionValid } from '@/unified-modules/account/account-library';

export const handleTryAgain = async (
  wrapperType: {
    isAndroid: boolean;
    isXsell: boolean;
  },
  reload: ({ preset }: { preset: SoftReloadPreset }) => void,
) => {
  const gameErrorType = useStore.getState().gameError?.type;

  Logger.logRumAction({
    name: '[GW][ERROR_HANDLING]: Try again ',
    eventType: DdEventType.Action,
    useCase: DdEventCategory.ErrorHandling,
    context: {
      wrapperType,
      gameErrorType,
    },
  });

  if (wrapperType.isAndroid && !wrapperType.isXsell) {
    if (gameErrorType === ERROR_TYPE.SESSION_EXPIRED) {
      resetGameStore(GameStoreParts.gameError);
      sendAndroidWrapperEvent(ANDROID_WRAPPER_EVENTS.GAME_CLOSE, '');
    } else {
      sendAndroidWrapperEvent(ANDROID_WRAPPER_EVENTS.RELOAD_GAME, '');
    }
    return;
  } else if (wrapperType.isXsell) {
    if (gameErrorType === ERROR_TYPE.SESSION_EXPIRED) {
      resetGameStore(GameStoreParts.gameError);
      triggerXsellLogin();
    } else {
      sendAndroidWrapperEvent(ANDROID_WRAPPER_EVENTS.RELOAD_GAME, '');
    }
    return;
  }
  let preset: SoftReloadPreset = SOFT_RELOAD_PRESET.IFRAME_ONLY;

  const isSessionValid = await isCurrentLocalSessionValid();

  if (gameErrorType === ERROR_TYPE.SESSION_EXPIRED) {
    preset = SOFT_RELOAD_PRESET.LOGOUT;
  } else if (isSessionValid) {
    preset = SOFT_RELOAD_PRESET.IFRAME_ONLY;
  } else {
    preset = SOFT_RELOAD_PRESET.LOGOUT;
  }

  reload({ preset });
};
